(ns teamoesterreich.admin-mode.lebensretter.opt-in.sort-table
  (:require ["react-virtualized" :as rv]
            [clojure.string]
            [goog.date.DateTime]
            [reagent.core :as r]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.view-state :as v-state]
            ))



(defonce LINE-HEIGHT 60)


(defn date-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)
        ;l-date (date-h/parse-local-date cell-data)
        ]
    ;(js/console.log l-date)
    (r/as-element
      [:span (if (> (count cell-data) 10)
               (str (subs cell-data 6 8) "." (subs cell-data 4 6) "." (subs cell-data 0 4))
               "-")])))


(defn inside-table [!st rows]
  (fn [m]
    (let [width (aget m "width")
          height (aget m "height")
          ]
      (r/as-element
        [:> rv/Table
         {:headerHeight    50
          :height          (- height 50)
          :rowCount        (count rows)
          ;:onScroll           (fn [a b c] (println "onScroll " a b c))
          ;:scrollToAlignment "start"
          :rowGetter       (fn [i]
                             (clj->js (get rows (.-index i) {})))

          :rowHeight       (+ LINE-HEIGHT 6)
          :width           width
          :headerClassName "headerColumn"
          :className       "LebensretterList"}

         [:> rv/Column
          {:label     "LR-ID"
           :dataKey   "uuid"
           :className "bordered exampleColumn"
           :width     300}]

         [:> rv/Column
          {:label     "Vorname"
           :dataKey   "firstName"
           :style     {:textAlign "left" :overflow "hidden"}
           :className "bordered exampleColumn"
           :width     120}]

         [:> rv/Column
          {:label     "Nachname"
           :dataKey   "lastName"
           :style     {:textAlign "left" :overflow "hidden"}
           :className "bordered exampleColumn"
           :width     120}]
         ;

         [:> rv/Column
          {:label     "E-Mail"
           :dataKey   "email"
           :className "bordered exampleColumn"
           :width     300}]

         [:> rv/Column
          {:label     "Telefonnummer"
           :dataKey   "phone"
           :className "bordered exampleColumn"
           :width     180}]

         [:> rv/Column
          {:label        "Geburtstag"
           :dataKey      "birthdate"
           :className    "bordered exampleColumn"
           :cellRenderer date-renderer
           :width        120}]

         [:> rv/Column
          {:label          "Adresse"
           :dataKey        "address"
           :className      "bordered exampleColumn"
           :cellDataGetter (fn [c]
                             (str (aget (.-rowData c) "address-rest") ", "
                                  (aget (.-rowData c) "address-postcode") " "
                                  (aget (.-rowData c) "address-city")))
           :width          500}]

         ]))))


(defn table [!st rows]
  (let [
        !st-selected (r/cursor v-state/app-state [:lr-list :selected])
        !cursor (r/cursor v-state/app-state [:lr-list :cursor])
        ]
    (fn []
      [:div
       (log/debug "rerender table")
       [:> rv/AutoSizer
        {:style         {:height "100%"}
         :data-cursor   (str @!cursor)
         :data-selected (str @!st-selected)}
        (inside-table !st rows)]
       ])))










